import axios from 'axios'
import { ApiResponse } from '../../../../../common/api/response.types'
import { FETCH_AUDIT_LOGS_URL, FETCH_AUDIT_TOPICS_URL } from '../../../api/consts'
import { IAuditQueryParams } from './query.types'
import { IAuditLogRecord, IAuditLogsPage, IAuditTopicInfo } from './response.types'

export const fetchAuditLogs = (params: IAuditQueryParams) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== '' && v !== undefined && v !== null)
  )
  return axios.get<ApiResponse<IAuditLogRecord[]> & IAuditLogsPage>(FETCH_AUDIT_LOGS_URL, {
    params: filteredParams,
  })
}

export const fetchAuditLogDetail = (id: number) => {
  return axios.get<ApiResponse<IAuditLogRecord>>(`${FETCH_AUDIT_LOGS_URL}/${id}`)
}

export const fetchAuditTopics = () => {
  return axios.get<ApiResponse<IAuditTopicInfo[]>>(FETCH_AUDIT_TOPICS_URL)
}
